var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcaseBlank = function SvgBriefcaseBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AABCBF",
    d: "M40 7.5V10h10V7.5c0-.275-.225-.5-.5-.5h-9c-.275 0-.5.225-.5.5M37 10V7.5C37 5.569 38.569 4 40.5 4h9C51.431 4 53 5.569 53 7.5V10h4c2.206 0 4 1.794 4 4v16c0 2.206-1.794 4-4 4H33c-2.206 0-4-1.794-4-4V14c0-2.206 1.794-4 4-4zm14.5 3H33c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h24c.55 0 1-.45 1-1V14c0-.55-.45-1-1-1z"
  })));
};
export default SvgBriefcaseBlank;